import { render } from "./chef-kitchen-edit-page.vue?vue&type=template&id=680c2ae0&scoped=true"
import script from "./chef-kitchen-edit-page.vue?vue&type=script&lang=js"
export * from "./chef-kitchen-edit-page.vue?vue&type=script&lang=js"

import "./chef-kitchen-edit-page.vue?vue&type=style&index=0&id=680c2ae0&lang=scss"
import "./chef-kitchen-edit-page.vue?vue&type=style&index=1&id=680c2ae0&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680c2ae0"]])

export default __exports__